var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.84,
    height: 106.858,
    viewBox: "0 0 114.84 106.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4443.252 -3012.03)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4508.158 3083.179v28.883a5.826 5.826 0 01-5.826 5.826h-52.255a5.825 5.825 0 01-5.825-5.826v-93.206a5.826 5.826 0 015.825-5.826h52.255a5.827 5.827 0 015.826 5.826v20.289m-63.906-10.618h63.906m-63.906 71.278h63.906",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.996,
    cy: 3.996,
    r: 3.996,
    transform: "translate(4472.208 3104.904)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4530.483 3077.595h-15.258l-15.566 12.3v-12.3h-34.415a2.983 2.983 0 01-2.983-2.983v-32.484a2.983 2.983 0 012.983-2.983h65.239a2.983 2.983 0 012.983 2.983v32.484a2.983 2.983 0 01-2.983 2.983z",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4473.782 3066.554h9.121a4 4 0 004-4h0a4 4 0 00-4-4h-5.121a4 4 0 01-4-4h0a4 4 0 014-4h9.121m-6.561-.002v-3.191m0 22.384v-3.191m18.031-15.07h24.717m-24.717 8.174h24.717m-24.717 8.175h24.717",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4520.568 3097.182v-6.392m26.534-4.599l-4.52-4.52m15.51-22.013h-6.392m-4.598-26.533l-4.52 4.52m-22.014-15.51v6.392"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9d4ec680fdbfd5d74ac2b0b1dfae6508.svg";
export { ForwardRef as ReactComponent };